import Tag from './shared/Tag';

export default class MustacheTag extends Tag {
	type: 'MustacheTag';
}
